module.exports = __webpack_public_path__ + "static/media/backgroundRadar.db715820.png";